import { Metadata } from '../../../../utils/spds/metadata';
import Super from '../../core/button.gjs';
import styles from './negative.module.scss';

const METADATA = Metadata.define({
  description: `
    Negative button used to perform an action.

    Extends the SPDS Core Button component.
  `,
  name: 'Negative Button',
});

export default class SpdsActionButtonNegative extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-button spds-action-button';
  hasBorder = true;
  variantClass = 'spds-action-button-negative';
  variantStyles = styles;
}

export const ACTION_BUTTON_NEGATIVE_METADATA = SpdsActionButtonNegative.metadata;
